import React, { useState, Fragment, useEffect} from "react";
import axios from "axios";
import axiosInstance from "../../../helpers/axiosInstance";
import { Route, Redirect, useHistory, BrowserRouter, Switch } from "react-router-dom";
import {
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Card,
    Button,
    NavLink,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    CardTitle,
    UncontrolledTooltip,
} from "reactstrap";

const Cuadricula=(props)=>{
    //const [value, onChange] = useState();
    const[select,setSelect]=useState();
    const [elements,setElements]=useState(props.elements.split(','));
    //console.log("propscuadricula");
    //console.log(props.elements);
    //console.log("elements");
    //console.log(elements.length);

    useEffect(()=>{
            //props.asigna(select);
        }  
    )
   
    const asigna1 =(index)=>
    {
        //console.log("index"+ index)
        props.asigna(index);
    }
    
    if(props.muestra){        
        //let cont= elements.length;
        //console.log("cont"+cont);
        return(
            <CardBody className="pb-1 justify-content-center text-xs-center">
                <Row className="justify-content-center">
                    <Container fluid>
                        <CardTitle
                        tag="h5"
                        className="mb-4 text-primary"
                        >
                            {props.title}
                        </CardTitle>
                    </Container>
                </Row>
                <Row className="justify-content-center">
                    <Container fluid>
                    <div class="react-calendar" style={{display: "flex", "align-items" : "left", "justify-content" : "left", "flex-wrap": "wrap"}}>
                    {
                        /*elements.map((item,index)=> {
                            console.log (item + ""+ index );
                            (<tr>
                                <td>
                                <a onClick={() => asigna1(index)} role="button" aria-haspopup="true" aria-expanded="false" class="btn-icon-only text-primary btn btn- btn-sm">{item}</a>
                                </td>
                            </tr>    )
                              /*<Row className="justify-content-center" key={index} onClick={() => asigna1(index)}>
                                {item}
                                {index}
                              </Row>*/
                              //}
                              
                        elements.map((element,index) => (
                            <div class="react-calendar__tile react-calendar__month-view__days__day react-calendar__month-view__days__day--neighboringMonth"
                            style={{"flex-basis": "14.2857%", "max-width": "14.2857%", "overflow": "hidden"}}
                            >
                            {/*<Row className="justify-content-center" key={index} onClick={() => asigna1(index)}>
                                {element}
                                {index}
                        </Row>*/}
                              
                            
                            
                                <button onClick={() => asigna1(index)} class="btn-icon-only text-darkgray btn btn- btn-sm fondocuadricula" 
                                >{element}</button>
                            
                            
                        
                            </div>
                    ))}
                    </div>
                        

                    </Container>
                </Row>                
            </CardBody>

        );

    }else{
        return(
            <Fragment>
                <div>
                    
                </div>
            </Fragment>
        );

    }
}
export default Cuadricula;